import { render } from "./Monitoring.vue?vue&type=template&id=1a3ca854&scoped=true"
import script from "./Monitoring.vue?vue&type=script&lang=js"
export * from "./Monitoring.vue?vue&type=script&lang=js"

import "./Monitoring.vue?vue&type=style&index=0&id=1a3ca854&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3ca854"]])

export default __exports__